module.exports = __webpack_public_path__ + "static/img/mycompass_loginbkg_mnt.8664dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycompass_loginbkg_mnt.jpg
// module id = WDGa
// module chunks = 0